module.exports = __webpack_public_path__ + "img/crib-blue.f6dc0359.svg";